module.exports = __webpack_public_path__ + "static/media/ic_dropzone.acfe57fc.svg";